import React from 'react';
import LoginPage from './Login.js';
// import RegisterPage from './Register.js';
import AccountPage from './Account.js';
import MapPage from './Map.js';
import ScanPage from './Scan.js';
import PaymentPage from './Payment.js';
import ManualCheckoutPage from './ManualCheckout.js';
import { url } from '../env.json';
import Cookies from 'universal-cookie';
const cookies = new Cookies();
const QRCode = require('qrcode');
const axios = require('axios');

export default class MainPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            register: false,
            isRegistered: false,
            isLoggedIn: false,
            loginType: 'user',
            userType: 'user',
            viewMap: false,
            viewScan: false,
            manualCheckout: false,
            scanType: 'checkout',
            counter: null,
            loginMessage: '',
            registerMessage: '',
            registerMessageColor: {color: 'black'},
            accName: '',
            userID: 0,
            userQRCode: '',
            userCupsOut: 0,
            userCupsSaved: 0,
            vendor: '',
            vendorID: 0,
            vendorInven: 0,
            vendorSignups: 0,
            vendorReturns: 0,
            vendorCheckouts: 0,
            showCamera: false,
            token: null,
            regUser: '',
            regPass: ''
        }
    }

    componentDidMount() {

        // Retrieve cookies from browser
        var session = cookies.get('logintoken');
        // console.log("Session token from cookie: " + session);

        if (session) {
            // Send token to server for verification
            axios.post(url + '/sessionLogin', {
                'message': 'active session',
                'token': session,
            })
            .then((resp) => {
                // Successful verification --> can log in user
                if (resp.data.status === 'ACTIVE USER') {
                    if (resp.data.loginType === 'user') {
                        QRCode.toDataURL(resp.data.userID, { scale: 8 })
                            .then((url) => {
                                this.setState({
                                    userQRCode: url
                                })
                            })
                            .catch((err) => {
                                // console.log(err);
                            })

                        this.setState({
                            register: false,
                            isLoggedIn: true,
                            userType: 'user',
                            loginMessage: '',
                            userID: resp.data.userID,
                            userCupsOut: resp.data.cupsout,
                            userCupsSaved: resp.data.cupsSaved,
                            accName: resp.data.name
                        })
                    } else if (resp.data.loginType === 'vendor') {
                        this.setState({
                            register: false,
                            isLoggedIn: true,
                            userType: 'vendor',
                            loginMessage: '',
                            vendorInven: resp.data.inventory,
                            vendorSignups: resp.data.signups,
                            vendorReturns: resp.data.returns,
                            vendor: resp.data.vendorName,
                            vendorID: resp.data.vendorID,
                            vendorCheckouts: resp.data.vendorCheckouts
                        })
                    }
                } else {
                    // do nothing
                }
            })
        }
    }

    retrieveUserHistory(userID) {
        // TODO: retrive user history and display
    }

    retrieveVendors() {
        // axios.get(url + '/listOfVendors')
        //     .then((resp) => {
        //         // console.log(resp.data.vendors[0]);
        //         return resp.data.vendors[0];
        //     })
    }

    render() {

        // If user is not logged in, show log in page
        if (this.state.register === false && this.state.isLoggedIn === false) {
            // console.log('Login')
            return (
                <LoginPage
                    // Allow user to go to register for a new account
                    // Only users can register for an account
                    // Vendors have accounts pre-registered for them
                    goToRegister={() => {
                        this.setState({
                            register: true,
                            isLoggedIn: false,
                            userType: 'user'
                        })
                    }
                    }

                    // loginType to pass to Login Page for rendering
                    loginType={this.state.loginType}

                    // Switch to user login from vendor login page
                    switchUserLogin={() => {
                        this.setState({
                            loginType: 'user',
                            loginMessage: ''
                        })
                    }
                    }

                    // Switch to vendor login from user login page
                    switchVendorLogin={() => {
                        this.setState({
                            loginType: 'vendor',
                            loginMessage: ''
                        })
                    }
                    }

                    // Process a user login
                    userLogin={(user, pass) => {

                        axios.post(url + '/userLogin', {
                            'message': 'user login',
                            'username': user.toLowerCase(),
                            'password': pass
                        })
                            .then((resp) => {
                                // console.log(resp.data.status);
                                if (resp.data.status.includes("SUCCESS")) {

                                    // this.retrieveUserHistory();

                                    QRCode.toDataURL(resp.data.userID, { scale: 8 })
                                        .then((url) => {
                                            this.setState({
                                                userQRCode: url
                                            })
                                        })
                                        .catch((err) => {
                                            // console.log(err);
                                        })

                                    this.setState({
                                        register: false,
                                        isLoggedIn: true,
                                        userType: 'user',
                                        loginMessage: '',
                                        userID: resp.data.userID,
                                        userCupsOut: resp.data.cupsout,
                                        accName: resp.data.name,
                                        token: resp.data.token,
                                        userCupsSaved: resp.data.cupsSaved
                                    })

                                    cookies.set('logintoken', resp.data.token, { path: '/' });
                                    // console.log('User login token: ' + cookies.get('logintoken'));

                                } else if (resp.data.status.includes("PASSWORD")) {
                                    this.setState({
                                        loginMessage: 'Incorrect password.'
                                    })
                                } else if (resp.data.status.includes("USERNAME")) {
                                    this.setState({
                                        loginMessage: 'User does not exist.'
                                    })
                                }
                            })
                            .catch((err) => {
                                // console.log(err);
                            })
                    }}

                    // Process a vendor login
                    vendorLogin={(user, pass) => {
                        axios.post(url + '/vendorLogin', {
                            'message': 'vendor login',
                            'username': user.toLowerCase(),
                            'password': pass
                        })
                            .then((resp) => {
                                // console.log(resp.data);
                                if (resp.data.status.includes("SUCCESS")) {
                                    // console.log(resp.data.signups);
                                    this.setState({
                                        register: false,
                                        isLoggedIn: true,
                                        userType: 'vendor',
                                        loginMessage: '',
                                        vendorInven: resp.data.inventory,
                                        vendorSignups: resp.data.signups,
                                        vendorReturns: resp.data.returns,
                                        vendor: resp.data.vendorName,
                                        vendorID: resp.data.vendorID,
                                        vendorCheckouts: resp.data.vendorCheckouts,
                                        token: resp.data.token
                                    })

                                    cookies.set('logintoken', resp.data.token, { path: '/' });
                                    // console.log('Vendor login token: ' + cookies.get('logintoken'));

                                } else if (resp.data.status.includes("PASSWORD")) {
                                    this.setState({
                                        loginMessage: 'Incorrect password.'
                                    })
                                } else if (resp.data.status.includes("USERNAME")) {
                                    this.setState({
                                        loginMessage: 'User does not exist.'
                                    })
                                }
                            })
                    }}

                    registerUser={(user,pass) => {
                        const regex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/g;
                        const regexPass = /^([a-zA-Z0-9@*#-]{8,20})$/gm;

                        let userFormat = regex.test(user);
                        let passFormat = regexPass.test(pass);

                        // console.log("Test results:\nUsername: " + userFormat + "\nPassword: "  + passFormat);
                        
                        if (user === '' || !userFormat) {
                            // No email or incorrect email format entered
                            // console.log("Registering: Incorrect email format.");

                            this.setState({
                                loginMessage: ''
                            })

                            setTimeout(() => {
                                this.setState({
                                    loginMessage: "Please enter a valid email address."
                                })
                            }, 150)
                        } else if (pass === '' || !passFormat) {
                            // No password or insufficient password format entered
                            // console.log("Registering: Incorrect password format.");

                            this.setState({
                                loginMessage: ''
                            })

                            setTimeout(() => {
                                this.setState({
                                    loginMessage: "Please enter a valid password. Password must be at least 8 characters long."
                                })
                            }, 150)                     
                        } else if (userFormat && passFormat) {
                            // console.log("Registering: Correct email & password format.");
                            // Correct email and password format, but need to check if email has already been registered
                            // Query database for existing email
                            // If email is already used, throw error
                            
                            axios.post(url + '/verifyEmail', {
                                'message': 'verifyEmail',
                                'email': user.toLowerCase()
                            })
                            .then((resp) => {
                                // console.log(resp.data.status);
                                if (resp.data.status === "SUCCESS") {
                                    // Proceed to payment page
                                    // Clear login message
                                    this.setState({
                                        loginMessage: '',
                                        regUser: user.toLowerCase(),
                                        regPass: pass,
                                        register: true
                                    })
                                } else {
                                    // Email has already been used
                                    this.setState({
                                        loginMessage: ''
                                    })

                                    setTimeout(() => {
                                        this.setState({
                                            loginMessage: "That email has already been used."
                                        })
                                    }, 150)
                                }
                            })
                        }
                    }}

                    // Login status message
                    loginMessage={this.state.loginMessage}
                />
            );
            // User wants to register a new account and is not current logged in
        } else if (this.state.register === true && this.state.isLoggedIn === false) {
            // console.log('Register')
            return (
                <PaymentPage
                    paymentSuccess={() => { axios.post(url + '/signup', {
                            'message': 'signup',
                            'userType': 'PAID',
                            'email': this.state.regUser.toLowerCase(),
                            'password': this.state.regPass
                        })
                        .then((resp) => {
                            // console.log(resp);
                            // console.log(resp.data.status);

                            if (resp.data.status === 'SUCCESS') {
                                this.setState({
                                    registerMessageColor: {color: 'green'},
                                    registerMessage: 'Payment & registration successful. Please login to continue.'
                                })
    
                                setTimeout(() => {
                                    this.setState({
                                        registerMessage: '',
                                        register: false
                                    })
                                }, 3500)
                            } else {
                                this.setState({
                                    registerMessageColor: {color: 'red'},
                                    registerMessage: 'Registration failed. Please email info@cuppy.ca for assistance.'
                                })
    
                                setTimeout(() => {
                                    this.setState({
                                        registerMessage: '',
                                        register: false
                                    })
                                }, 5000)
                            }
                        })
                    }}

                    paymentFail={(errMsg) => {
                        // this.setState({
                        //     registerMessageColour: {color: 'red'},
                        //     registerMessage: 'Payment failed. Please try again later.'
                        // })

                        if (errMsg === 'PAN_FAILURE') {
                            this.setState({
                                registerMessageColor: {color: 'red'},
                                registerMessage: 'Payment failed. Please try again later.'
                            })
                        } else {
                            this.setState({
                                registerMessageColor: {color: 'red'},
                                registerMessage: 'ERROR: '  + errMsg
                            })
                        }
                    }}


                    cancelPayment={() => {
                        this.setState({
                            register: false,
                            registerMessage: '',
                            registerMessageColor: {color: 'black'},
                            loginMessage: ''
                        })
                    }}

                    changeRegisterMessage={(errorMessage) => {
                        this.setState({
                            registerMessageColor: {color: 'red'},
                            registerMessage: errorMessage
                        })
                    }}

                    registerMessageColor={this.state.registerMessageColor}
                    registerMessage={this.state.registerMessage}  
                    />
                // <RegisterPage
                //     // Return to login page from register
                //     goToLogin={() => {
                //         clearTimeout(this.counter);
                //         this.setState({
                //             register: false,
                //             isRegistered: false,
                //             isLoggedIn: false,
                //             userType: 'user',
                //             counter: null,
                //             loginMessage: ''
                //         })
                //     }
                //     }

                //     // Register new account     
                //     register={(name, user, pass) => {
                //         console.log(name, user, pass);
                //         axios.post(url + '/signup', {
                //             'message': 'signup',
                //             'userType': 'PAID',
                //             'username': user,
                //             'password': pass,
                //             'fullName': name,
                //             'location': 1
                //         })
                //             .then((resp) => {
                //                 console.log(resp.data);
                //                 // SUCCESSFUL REGISTRATION
                //                 // TODO: HANDLE PAYMENT INFORMATION
                //                 if (resp.data.includes("SUCCESS")) {
                //                     // Take user to thank you page
                //                     this.setState({
                //                         isRegistered: true
                //                     })

                //                     // Return to login page after timeout
                //                     this.counter = setTimeout(() => {
                //                         this.setState({
                //                             register: false,
                //                             isRegistered: false,
                //                             isLoggedIn: false,
                //                             userType: 'user',
                //                             counter: null,
                //                             registerMessage: ''
                //                         })
                //                     }, 3000);
                //                 } else if (resp.data.includes("TAKEN")) {
                //                     this.setState({
                //                         registerMessage: 'Username already taken.'
                //                     })
                //                 } else {
                //                     this.setState({
                //                         registerMessage: 'Error. Please try again later.'
                //                     })
                //                 }
                //             })
                //             .catch((err) => {
                //                 console.log(err);
                //             })
                //     }}

                //     // Retrieve list of vendors
                //     listOfVendors={() => {
                //         this.retrieveVendors();
                //     }}

                //     // Registered status
                //     isRegistered={this.state.isRegistered}

                //     // Register status message
                //     registerMessage={this.state.registerMessage}
                // />
            );
            // Show user's account page when they are logged in
        } else if (this.state.isLoggedIn === true && this.state.viewMap === false && this.state.viewScan === false && this.state.manualCheckout === false) {
            // console.log('Account Page (logged in)');
            return (
                <AccountPage
                    // Account type to pass to account page for rendering
                    userType={this.state.userType}

                    manualCheckout={() => {
                        this.setState({
                            manualCheckout: true
                        })
                    }}

                    // Let user access map of CUPPY locations
                    goToMap={() => {
                        this.setState({
                            viewMap: true
                        })
                    }}

                    // Log out and return to login page
                    logOut={() => {
                        this.setState({
                            register: false,
                            isLoggedIn: false,
                            userType: 'user',
                            userQRCode: '',
                            loginMessage: '',
                            token: null
                        })

                        cookies.remove('logintoken');
                    }
                    }

                    // Open scanner to checkout
                    checkoutScan={() => {
                        this.setState({
                            viewScan: true,
                            scanType: 'checkout',
                            showCamera: true
                        })
                    }}

                    // Open scanner to checkin
                    checkinScan={() => {
                        this.setState({
                            viewScan: true,
                            scanType: 'checkin',
                            showCamera: true
                        })
                    }}

                    // Open scanner to refill
                    refillScan={() => {
                        this.setState({
                            viewScan: true,
                            scanType: 'refill',
                            showCamera: true
                        })
                    }}

                    // User account information
                    userQRCode={this.state.userQRCode}
                    userID={this.state.userID}
                    userCupsOut={this.state.userCupsOut}
                    name={this.state.accName}
                    userCupsSaved={this.state.userCupsSaved}

                    // Vendor stats
                    vendorName={this.state.vendor.toLowerCase()}
                    vendorInven={this.state.vendorInven}
                    vendorSignups={this.state.vendorSignups}
                    vendorReturns={this.state.vendorReturns}
                    vendorCheckouts={this.state.vendorCheckouts}
                />
            );
        } else if (this.state.isLoggedIn === true && this.state.viewMap === true) {
            // console.log("Showing partner locations (map page)");
            return (
                <MapPage
                    returnToAccount={() => {
                        this.setState({
                            viewMap: false
                        })
                    }
                    }
                />
            );
        } else if (this.state.isLoggedIn === true && this.state.viewScan === true) {
            // console.log("Show scanner for QR code (scan page)");
            return (
                <ScanPage
                    // Cancel scan and return to account page
                    cancelScan={() => {
                        this.setState({
                            viewScan: false,
                            showCamera: false
                        })
                    }
                    }

                    // Show QR scan result
                    showResult={() => {
                        this.setState({
                            showCamera: false
                        })
                    }}

                    // Update vendor stats after check-in or checkout
                    updateVendorStats={() => {
                        // console.log("Update vendor stats");
                        axios.post(url + '/updateVendorStats', {
                            'vendorID': this.state.vendorID
                        })
                            .then((resp) => {
                                // console.log(resp.data.signups);
                                this.setState({
                                    vendorInven: resp.data.inventory,
                                    vendorReturns: resp.data.returns,
                                    vendorCheckouts: resp.data.vendorCheckouts,
                                    vendorSignups: resp.data.signups
                                })
                            })
                    }}

                    // Vendor ID
                    vendorID={this.state.vendorID}

                    // Show camera
                    showCamera={this.state.showCamera}

                    // Scan type to pass to Scan Page for rendering
                    scanType={this.state.scanType}
                />
            );
        } else if (this.state.isLoggedIn === true && this.state.manualCheckout === true) {
            // console.log("Manual checkout page")
            return (
                <ManualCheckoutPage
                    cancelManualCheckout={() => {
                        this.setState({
                            manualCheckout: false
                        })
                    }}

                    userID={this.state.userID}
                />
            );
        }
    }
}